import alloyAnalytics from '@telus/alloy-analytics'
import { QuickLinksProps } from '../../blocks/core/QuickLinks/QuickLinks'

type ClickProps = {
  item: QuickLinksProps['quickLinksItem'][number]
}

const alloyEvents = {
  click: ({ item }: ClickProps) => {
    const linkName = `anchor_link-${item.text}`
    const linkClicks = { name: linkName, linkName }
    alloyAnalytics.event('linkClicks').webInteraction(linkClicks).fire()
  },
}

export default alloyEvents
